import { render, staticRenderFns } from "./ProjIncome.vue?vue&type=template&id=74b0f05c"
import script from "./ProjIncome.vue?vue&type=script&lang=js"
export * from "./ProjIncome.vue?vue&type=script&lang=js"
import style0 from "./ProjIncome.vue?vue&type=style&index=0&id=74b0f05c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports